import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { html, nothing } from "lit";
import "../../atom/Icon/index.js";
import "../Link/index.js";
import "../Button/index.js";
import Warehouse from "./assets/Warehouse.svg.js";
import { prop } from "../../../decorators/prop/index.js";
import { getMessages } from "./utils.js";
import { testingAttr } from "../../../directives/testingAttr.js";
import { TestingAttrs } from "./emptyState.selectors.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfEmptyState = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_with_image = true;
    this.dsf_action_target = "link";
  }
  onActionClick(event) {
    this.emit({ name: "call-to-action", payload: event });
  }
  render() {
    const messages = getMessages(this);
    const image = this.dsf_with_image ? html`<slot name="image">
          <img src="${Warehouse}" alt="" />
        </slot>` : nothing;
    const action = this.dsf_action_target === "link" ? html`<span class="dsf-text-s">${messages.action.preText}</span>
            <dsf-link
              class="select-none"
              @click="${this.onActionClick}"
              ${testingAttr(TestingAttrs.actionButton)}
            >
              ${messages.action.text}
            </dsf-link>` : html`<span class="dsf-text-s">${messages.action.preText}</span>
            <dsf-button
              @click="${this.onActionClick}"
              class="mt-24"
              dsf_size="small"
              ${testingAttr(TestingAttrs.actionButton)}
            >
              ${messages.action.text}
            </dsf-button>`;
    return html`
      <div class="flex flex-auto flex-col items-center text-neutral-700">
        ${image}
        <span class="dsf-text-m-semibold my-24 text-center">${messages.noMatchingResults}</span>
        ${action}
      </div>
    `;
  }
};
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfEmptyState.prototype, "dsf_with_image", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfEmptyState.prototype, "dsf_action_target", 2);
__decorateClass([
  prop({ type: String })
], DsfEmptyState.prototype, "dsf_action_pre_text", 2);
__decorateClass([
  prop({ type: String })
], DsfEmptyState.prototype, "dsf_action_text", 2);
__decorateClass([
  prop({ type: String })
], DsfEmptyState.prototype, "dsf_no_matching_results_text", 2);
DsfEmptyState = __decorateClass([
  defineElement("dsf-empty-state")
], DsfEmptyState);
export {
  DsfEmptyState
};
